import { Type } from "class-transformer";
import {
  IsBoolean,
  IsDate,
  IsInt,
  IsString,
  ValidateIf,
} from "class-validator";

export default class PublicCongress {
  @IsInt() public readonly id!: number;
  @IsString() public readonly lc!: string;
  @IsString() public readonly title!: string;
  @IsString() public readonly short_title!: string;

  @ValidateIf((obj) => obj.logo !== null)
  @IsString()
  public readonly logo!: string | null;

  @ValidateIf((obj) => obj.description !== null)
  @IsString()
  public readonly description!: string | null;

  @IsBoolean() public readonly international!: boolean;

  @ValidateIf((obj) => obj.abstract_deadline !== null)
  @Type(() => Date)
  @IsDate()
  public readonly abstract_deadline!: Date;

  @Type(() => Date)
  @IsDate()
  public readonly begin!: Date;

  @Type(() => Date)
  @IsDate()
  public readonly end!: Date;

  @ValidateIf((obj) => obj.location !== null)
  @IsString()
  public readonly location!: string | null;

  @ValidateIf((obj) => obj.url !== null)
  @IsString()
  public readonly url!: string | null;

  @ValidateIf((obj) => obj.facebook !== null)
  @IsString()
  public readonly facebook!: string | null;

  @ValidateIf((obj) => obj.instagram !== null)
  @IsString()
  public readonly instagram!: string | null;

  @ValidateIf((obj) => obj.youtube !== null)
  @IsString()
  public readonly youtube!: string | null;

  @ValidateIf((obj) => obj.tiktok !== null)
  @IsString()
  public readonly tiktok!: string | null;
}
